<template>
    <div id="imageCarousel">
      <swiper
        :slides-per-view="4"
        :space-between="20"
        :loop="true"
        :autoplay="{ delay: 5000 }"
        pagination
        @slideChange="updatePagination"
        class="video-gallery-slider"
      >
        <swiper-slide v-for="(item, index) in videoGallery" :key="index">
          <img :src="item.image_path" class="d-block w-100">
        </swiper-slide>
        <DotsPagination :currentSlide="currentSlide" :totalSlides="videoGallery.length" />

      </swiper>
  
    </div>
  </template>
  
  <script>
  import { Swiper, SwiperSlide } from "swiper/vue";
  import "swiper/css";
  import "swiper/css/pagination";
  import DotsPagination from "@/components/Pagination/DotsPagination.vue";
  
  export default {
    props: ["videoGallery"],
    components: {
      Swiper,
      SwiperSlide,
      DotsPagination
    },
    data() {
      return {
        currentSlide: 0, // Track active slide
      };
    },
    methods: {
      updatePagination(swiper) {
        this.currentSlide = swiper.realIndex;
      },
    },
  };
  </script>
  
  <style scoped>
  #imageCarousel {
    margin-top: 50px;
  }
  
  .video-gallery-slider {
    width: 100%;
  }
  
  img {
    width: 100%;
    height: 425px;
    object-fit: cover;
    border-radius: 20px;
  }
  </style>
  